// import { Form } from './modules/form-validate/form';
import { iosVhFix } from './utils/ios-vh-fix';
import { initFancy } from './modules/init-fancy.js';
import { initBurger } from './modules/header/init-burger.js';

// import { Tabs } from './modules/tabs';
// import { initBurger } from './modules/header/init-burger';
//
// const breakpoint = 768;
// const breakpoint2 = 1200;

// ---------------------------------

window.addEventListener('DOMContentLoaded', () => {

  // Utils
  // ---------------------------------

  iosVhFix();

  // Modules
  // ---------------------------------

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
    initBurger();
    initFancy();
  });
});
